angular.module('common',
    [
        'common.directives.teethConverter',
        'common.directives.focus',
        'common.directives.urlencode',
        'common.directives.recompile',
        'common.directives.buttonSliderMenu',
        'common.directives.omSpinner',
        'common.directives.appLoadingAnimation',
        'common.directives.omNumericTextBox',
        'common.directives.omAutocomplete',
        'common.directives.omDatePicker'
    ]);